// extracted by mini-css-extract-plugin
export default {"container":"CodeEditorContainer_container__1Kjb5","withOpacity":"CodeEditorContainer_withOpacity__07VEH"};